import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M11.9995 21C17.2462 21 21.4995 16.7467 21.4995 11.5C21.4995 6.25329 17.2462 2 11.9995 2C6.75281 2 2.49951 6.25329 2.49951 11.5C2.49951 16.7467 6.75281 21 11.9995 21Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4995 22L20.4995 20"
        stroke="#F59C53"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Icon;
